import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { OrganizationTable } from "@/features/organization/OrganizationTable";

export function OrganizationIndex() {
  return (
    <>
      <Breadcrumbs />
      <H2>Organization List</H2>
      <OrganizationTable />
    </>
  );
}
